export default __webpack_public_path__ + "locales/vi/InviteDialog.json?hash=f7f068640056d8f845975ddc82735c90";